import { render } from "./favorite-icon.vue?vue&type=template&id=46ccf4be"
import script from "./favorite-icon.vue?vue&type=script&lang=js"
export * from "./favorite-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__